import {Component, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {NotificationsServices} from '../../services/app/notifications.service';
import {eNotificationType} from '../../enumerators/app/notificationType.enum';
import {UserProvider} from '../../providers/app/user.prov';

@Component({
  selector: 'app-recover-password-dialog',
  templateUrl: './recover-password-dialog.component.html',
  styleUrls: ['./recover-password-dialog.component.scss']
})
export class RecoverPasswordDialogComponent implements OnInit {
  public firstStep: FormControl;
  public rePassword: FormControl;
  public formCompany: FormGroup;
  public hide = true;
  public hideCode = true;

  constructor(public dialogRef: MatDialogRef<RecoverPasswordDialogComponent>,
              private notificationsService: NotificationsServices,
              private userProv: UserProvider,
              private formBuilder: FormBuilder) {
    this.firstStep = new FormControl('', Validators.required);
    this.rePassword = new FormControl('', Validators.required);
  }

  ngOnInit() {
    this._initialize();
  }

  _initialize() {
    this.formCompany = this.formBuilder.group({
      'email': ['', Validators.compose([Validators.required])],
      'code': ['', Validators.compose([Validators.required])],
      'newPassword': ['', Validators.compose([Validators.required])]
    });
  }

  saveNewPassword() {
    if (this.formCompany.invalid) {
      this.notificationsService.showNotification(eNotificationType.ERROR, 'Atención',
        'Por favor llene todos los campos para cambiar su contraseña');
    } else if (this.rePassword.invalid) {
      this.notificationsService.showNotification(eNotificationType.ERROR, 'Atención',
        'Vuelva a escribir su contraseña para continuar');
      this.rePassword.markAsDirty();
    } else if (this.formCompany.get('newPassword').value !== this.rePassword.value) {
      this.notificationsService.showNotification(eNotificationType.ERROR, 'Error',
        'Las contraseñas no coinciden, por favor de verificar');
    } else {
      this.userProv.updatePasswordByType(this.formCompany.value).subscribe(res => {
        this.notificationsService.showNotification(eNotificationType.SUCCESS, res.msg, '');
        this.onClose();
      }, error => {
        console.log(error);
        const msgError = JSON.parse(error._body);
        this.notificationsService.showNotification(eNotificationType.ERROR, msgError.msg, '');
        this.onClose();
      });
    }
  }

  onClose() {
    this.dialogRef.close();
  }

  cleanForm() {
    this.formCompany.reset();
    this.rePassword.reset();
  }

}
